"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconHeader = _interopRequireDefault(require("../IconHeader"));

var _Statistic = _interopRequireDefault(require("../Statistic"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BareStatisticHeader = function BareStatisticHeader(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? '2' : _ref$level,
      icon = _ref.icon,
      _ref$na = _ref.na,
      na = _ref$na === void 0 ? false : _ref$na,
      _ref$score = _ref.score,
      score = _ref$score === void 0 ? 0 : _ref$score,
      children = _ref.children,
      className = _ref.className;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(_Statistic.default, {
    score: score,
    na: na
  }), _react.default.createElement(_IconHeader.default, {
    level: level,
    icon: icon
  }, children));
};

var StatisticHeader = (0, _styledComponents.default)(BareStatisticHeader).withConfig({
  displayName: "StatisticHeader",
  componentId: "sc-19u712i-0"
})(["display:flex;align-items:center;svg{width:40px;height:40px;margin-right:16px;fill:", ";}"], function (p) {
  return p.theme.global.colors.brand;
});
var _default = StatisticHeader;
exports.default = _default;